"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "First of all, let’s figure out the belief that is driving the checking. Do any of these feel true to you?",
  type: "radio",
  options: ["Collecting information helps me get ahead of problems", "Checking for symptoms regularly helps me tell if I’m in danger", "Not focusing on symptoms or having all the information is tempting fate"],
  batteryId: "CORONA_BELIEFS_ABOUT_HEALTH_CHECKING",
  meta: {
    summaryTitle: "let’s figure out the belief that is driving the checking. Do any of these feel true to you?"
  }
}, {
  prompt: "Or any of these?",
  type: "radio",
  options: ["Worrying about my health gets me prepared for anything", "Worrying helps me solve my health problems", "If I keep worrying, I can prevent illness and disease"],
  batteryId: "CORONA_BELIEFS_ABOUT_HEALTH_CHECKING",
  meta: {
    summaryTitle: "Or any of these?"
  }
}, {
  prompt: "Is there a personal belief (like a subconscious goal) that you have that’s driving your checking?",
  type: "textarea",
  batteryId: "CORONA_BELIEFS_ABOUT_HEALTH_CHECKING",
  meta: {
    answerLabel: "Personal belief that’s driving your checking?",
    summaryTitle: "Is there a personal belief (like a subconscious goal) that you have that’s driving your checking?"
  }
}, {
  prompt: "If you were diagnosed with a health issue tomorrow, would checking have truly prepared you for it?",
  type: "radio",
  options: ["Yes", "Probably not"],
  batteryId: "CORONA_BELIEFS_ABOUT_HEALTH_CHECKING",
  meta: {
    summaryTitle: "If you were diagnosed with a health issue tomorrow, would checking have truly prepared you for it?"
  }
}, {
  prompt: "Is checking truly protecting you and keeping you well?",
  type: "radio",
  options: ["Yes", "Probably not"],
  batteryId: "CORONA_BELIEFS_ABOUT_HEALTH_CHECKING",
  meta: {
    summaryTitle: "Is checking truly protecting you and keeping you well?"
  }
}, {
  prompt: "Is constant checking of your symptoms increasing the intensity or frequency of strange sensations in your body?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: "CORONA_BELIEFS_ABOUT_HEALTH_CHECKING",
  meta: {
    summaryTitle: "Is constant checking of your symptoms increasing the intensity or frequency of strange sensations in your body?"
  }
}, {
  prompt: "Are you setting off your fight or flight response (anxiety/panicky feelings) by checking or information gathering?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: "CORONA_BELIEFS_ABOUT_HEALTH_CHECKING",
  meta: {
    summaryTitle: "Are you setting off your fight or flight response (anxiety/panicky feelings) by checking or information gathering?"
  }
}, {
  prompt: "If a child was focusing on symptoms or checking for information as much as you are would you encourage them to keep doing it?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: "CORONA_BELIEFS_ABOUT_HEALTH_CHECKING",
  meta: {
    summaryTitle: "If a child was focusing on symptoms or checking for information as much as you are would you encourage them to keep doing it?"
  }
}, {
  prompt: "What’s your personal reason about why you would or wouldn’t encourage them to keep doing it?",
  type: "textarea",
  batteryId: "CORONA_BELIEFS_ABOUT_HEALTH_CHECKING",
  meta: {
    answerLabel: "Personal reasons would or wouldn’t keep doing it",
    summaryTitle: "What’s your personal reason about why you would or wouldn’t encourage them to keep doing it?"
  }
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;